import Typography from '@proofpoint/fuse/components/Typography';
import Divider from '@proofpoint/fuse/components/Divider';
import { Box } from '@mui/material';
import { withStyles } from '@mui/styles';
import React from 'react';

const styles = {
  link: {
    color: '#757575', 
    textDecoration: 'none',
    '&:visited': {
      color: '#757575',
    },
  },
}

const Footer = (props) => {
  const { classes } = props;
  const currentYear = new Date().getFullYear();
  const version = process.env.REACT_APP_VERSION;
  return(
    <>
      <Divider light />
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="body2" gutterBottom >
          <a href="https://www.cloudmark.com" className={classes.link}>©{currentYear} Cloudmark Inc</a>. All rights reserved
        </Typography>
        <Typography variant="body2" gutterBottom>
          <a href="https://www.proofpoint.com/us/legal/privacy-policy" className={classes.link}>Privacy Policy</a><br/>
          {version}
        </Typography>
      </Box>
    </>
  );
}

export default withStyles(styles)(Footer)
